import _cloneDeep from 'lodash/cloneDeep';

export const getEmptyEntitySelectionContext = (): EntitySelectionContext =>
    _cloneDeep({
        activeEntities: [],
        disableSelection: false,
        entities: [],
        modifiedAt: 0,
        onSelectEntity: null,
        priorSelectedEntityId: null,
        selectedEntity: null,
        selectedEntityId: null,
        userId: null,
        viewAll: false,
    });
